import React from 'react';
import './Tooltip.css';

const Tooltip = ({ description, status, size = 'small' }) => {
  return (
    <div className={`tooltipContainer ${size}`}>
      <span className={`status ${status} tooltipIcon`}>?</span>
      <span className="tooltipText">{description}</span>
    </div>
  );
};

export default Tooltip;
